// O CONTATO DO SUPORTE ADVUP (Fase 3A, 13/10/2026). Victor: a tela dizia "fale
// com o suporte" sem dizer como. Um lugar só para o endereço — os textos
// recebem `{ email }` daqui, e o botão da tela de acesso pausado abre o e-mail.
export const EMAIL_DO_SUPORTE = 'suporte@advup.com.br';
export const LINK_DO_SUPORTE = `mailto:${EMAIL_DO_SUPORTE}`;
